import { CATMANVIEW } from '../../constants/constant';
import { getAxiosAuthHeader, checkStatus } from '../../helper/utils';

/**
 * Generic post api service
 * @param {Array} request - List of apps to be passed as a request body to the API.
 * @param {string} api - The api url which will be used to call and get response.
 * @param {string} userInfo - The userInfo which will contain the access token.
 * @returns {Object} - Json
 */

export const saveData = async (request, api, userInfo, isPublish = false) => {
	const { headers } = getAxiosAuthHeader(userInfo);
	if (!isPublish) {
		const view = sessionStorage.getItem('view');

		if (view === CATMANVIEW) {
			request['persona'] = {
				view: 'CATMAN',
			};
		} else {
			request['persona'] = {
				view: 'SUPPLIER',
			};
		}
	}

	const response = await fetch(api, {
		method: 'POST',
		headers: {
			...headers,
			'Content-Type': 'application/json',
			correlationId: '1234',
		},
		body: JSON.stringify(request),
	});
	checkStatus(response?.status);
	const { ok, status } = response;
	let json = {};
	try {
		json = await response?.json();
	} catch (e) {
		json = await JSON.stringify(response);
	}
	return { ok, json, statusCode: status };
};
export const putData = async (api, userInfo) => {
	const { headers } = getAxiosAuthHeader(userInfo);
	const response = await fetch(api, {
		method: 'PUT',
		headers: {
			...headers,
		},
	});
	checkStatus(response?.status);
	return { ok: true, statusCode: 200 };
};
export const deleteData = async (api, userInfo) => {
	const { headers } = getAxiosAuthHeader(userInfo);
	const response = await fetch(api, {
		method: 'DELETE',
		headers: {
			...headers,
		},
	});
	checkStatus(response?.status);
	return { ok: true, statusCode: 200 };
};
/**
Generic Patch Api Service
@param {Object} request - List of keys value pairs to be passed as a request body to the API.
@param {string} api - The api url which will be used to call and get response.
@param {string} userInfo - The userInfo which will contain the access token.
*/

export const patchData = async (request, api, userInfo) => {
	const { headers } = getAxiosAuthHeader(userInfo);
	const view = sessionStorage.getItem('view');

	if (view === CATMANVIEW) {
		request['persona'] = {
			view: 'CATMAN',
		};
	} else {
		request['persona'] = {
			view: 'SUPPLIER',
		};
	}
	const response = await fetch(api, {
		method: 'PATCH',
		headers: {
			...headers,
			'Content-Type': 'application/json',
			correlationId: '1234',
		},
		body: JSON.stringify(request),
	});
	checkStatus(response?.status);
	const { ok, status } = response;
	let json = {};
	try {
		json = await response?.json();
	} catch (e) {
		console.log(e);
	}
	return { ok, json, statusCode: status };
};
